<template>
  <el-dialog
    :title="dialogTitle"
    :visible.sync="isDialogShow"
    center
    width="60%"
    class="sop_dialog"
  >
    <el-table
      :data="dialogTableData" border
      style="width: 100%;border-radius: 0 !important"
      :header-cell-style="{ background: '#f7f7f9' }"
    >
      <el-table-column
        v-for="(item, idx) in tableHeaderList"
        :key="idx"
        align="center"
        :label="item.label"
        :prop="item.prop"
        :min-width="item.cloWidth"
      />
      <!-- 操作    编辑/查看：dialogType === 2 -->
      <el-table-column
        v-if="dialogType === 2" :label="$t('collectionCenter.operation')" align="center"
        width="235"
      >
        <template slot-scope="scope">
          <el-button
            size="small" round
            @click="preView(scope.row)"
          >{{ $t('operationCenter.Preview') }}</el-button>
          <el-button
            size="small" round
            @click="download(scope.row)"
          >{{ $t('GlobalSetObj.Download') }}</el-button>
        </template>
      </el-table-column>
    </el-table>
  </el-dialog>
</template>

<script>
import { sopVersionHistory, sopTotalCount } from '@/api/sop';
import { getUserName } from '@/utils/asyncTools';
import { getUserIdAndNameObj } from '@/enums/storageEnum';

export default {
  name: 'SearchMenu',
  data() {
    return {
      dialogTitle: '',
      isDialogShow: false,
      dialogType: null,
      tableHeaderList: [],
      dialogTableData: [],
      // 累计预览/下载次数
      totalCountHeaderList: [
        { label: this.$t('dictionary.language'), prop: 'languageName', cloWidth: 120 },
        { label: this.$t('navbar.documentName'), prop: 'documentName', cloWidth: 120 },
        { label: this.$t('navbar.totalPreviewCount'), prop: 'totalPreviewCount', cloWidth: 150 },
        { label: this.$t('navbar.totalDownloadCount'), prop: 'totalDownloadCount', cloWidth: 150 }
      ],
      // 历史版本数据
      historicalVersionHeaderList: [
        { label: this.$t('Resource.VersionNum'), prop: 'versionName', cloWidth: 100 },
        { label: this.$t('basicData.fileName'), prop: 'fileName', cloWidth: 120 },
        { label: this.$t('GlobalSetObj.Updater'), prop: 'updateName', cloWidth: 120 },
        { label: this.$t('GlobalSetObj.UpdateTime'), prop: 'uploadTime', cloWidth: 120 }
      ]
    };
  },
  methods: {
    getData(data, title, type) {
      console.log('data, title, type', data, title, type);
      this.dialogTitle = title;
      this.dialogType = type;
      this.dialogTableData = [];
      if (type === 1) {
        this.tableHeaderList = this.totalCountHeaderList;
        const totalCountForm = {
          sopId: data.id
        };
        sopTotalCount(totalCountForm).then(res => {
          if (res.code === 200) {
            this.isDialogShow = true;
            this.dialogTableData = res.data.map(item => {
              item.languageName = item.language === 'zh-CN' ? '中文' : item.language === 'pt-BR' ? 'Português' : '';
              return item;
            });
          }
        });
      } else if (type === 2) {
        // 编辑窗口点进来的  type: 2
        this.tableHeaderList = this.historicalVersionHeaderList;
        const historyForm = {
          documentId: data.id
        };
        sopVersionHistory(historyForm).then(res => {
          if (res.code === 200) {
            this.isDialogShow = true;
            this.dialogTableData = res.data.map(item => {
              const updateName = getUserName(item.uploadUser, getUserIdAndNameObj());
              item.updateName = updateName;
              return item;
            });
          }
        });
      }
    },
    preView(row) {
      if (!row.fileUrl) {
        this.$message.warning(this.$t('navbar.fileNotExist'));
        return;
      }
      const ext = (row.fileName || '').substring(row.fileName.lastIndexOf('.') + 1).toLowerCase();
      const officeTypes = ['doc', 'docx', 'xls', 'xlsx', 'pptx'];
      const imgTypes = ['png', 'jpg', 'jpeg'];

      if (officeTypes.includes(ext)) {
        // Office文件使用在线预览
        const encodedUrl = encodeURIComponent(row.fileUrl);
        window.open(`https://view.officeapps.live.com/op/view.aspx?src=${encodedUrl}`, '_blank');
      } else if (imgTypes.includes(ext)) {
        // 图片直接打开
        const win = window.open('', '_blank');
        win.document.write(`
              <html>
                <head>
                  <title>图片预览</title>
                  <style>
                    body { margin: 0; display: flex; justify-content: center; align-items: center; height: 100vh; background: #f5f5f5; }
                    img { max-width: 95%; max-height: 95%; object-fit: contain; }
                  </style>
                </head>
                <body>
                  <img src="${row.fileUrl}" />
                </body>
              </html>
            `);
        win.document.close();
      } else if (['pdf', 'PDF'].includes(ext)) {
        fetch(row.fileUrl)
          .then(response => response.blob())
          .then(blob => {
            const blobUrl = URL.createObjectURL(blob);
            window.open(blobUrl, '_blank');
            setTimeout(() => URL.revokeObjectURL(blobUrl), 5000);
          })
          .catch(() => {
            // 降级方案：直接打开原链接
            window.open(row.fileUrl, '_blank');
          });
      } else {
        // 其余文件下载
        window.open(row.fileUrl, '_blank');
      }
    },
    download(row) {
      if (!row.fileUrl) {
        this.$message.warning(this.$t('navbar.fileNotExist'));
        return;
      }
      const link = document.createElement('a');
      link.href = row.fileUrl;
      link.download = row.fileName;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
};
</script>

<style lang="scss" scoped>
.sop_dialog ::v-deep .el-dialog--center {
  text-align: left !important;
}
.sop_dialog ::v-deep .el-dialog__title {
  font-weight: 700;
  font-size: 17px;
}
.sop_dialog ::v-deep .el-table__header .el-table__cell .cell {
  font-weight: bold;
  font-size: 15px;
  color: #000;
}
</style>
